module.exports = __webpack_public_path__ + "static/partnership_process_obj03@2x-f219181a5105f2ae51499f3fd47d631a.png";